<div class="gt-routes-list-containerss gt-grid-left-top-corner-flat societies-container">
    <div class="societies-page">
        <!-- One bar for both views, so search and buttons stay put when switching. -->
        <div class="societies-bar">
            <dx-text-box
                [(value)]="searchTerm"
                mode="search"
                valueChangeEvent="keyup"
                width="100%"
                class="custom-search-panel"
                i18n-placeholder="@@societiesSearch"
                placeholder="Gesellschaften suchen..."
            ></dx-text-box>
            <div class="societies-bar-right">
                <app-view-toggle [views]="views" [activeKey]="view" (viewChange)="changeView($event)"></app-view-toggle>
                <app-gpd-button i18n-text="@@addSociety" text="Gesellschaft erstellen" icon="add" (onClick)="goToAddSociety()"></app-gpd-button>
            </div>
        </div>
        @if (view === 'orgchart') {
        <app-society-org-chart class="societies-content" [nodes]="orgChartNodes" [edges]="orgChartEdges" [salesModels]="orgChartSalesModels" [searchTerm]="searchTerm" [demo]="demo"></app-society-org-chart>
        } @else {
        <div class="societies-content">
            <dx-data-grid id="gridContainer"
                [dataSource]="societies" class="gt-data-grid-style contacts-societies-list"
                [allowColumnReordering]="true" [rowAlternationEnabled]="true" height="100%"
                [allowColumnResizing]="true" [columnResizingMode]="'widget'"
                [columnAutoWidth]="false" [showBorders]="true" [scrolling]="{ mode: 'standard', useNative: true }"
                [width]="'100%'" [hoverStateEnabled]="true" (onRowClick)="showDetails($event)"
                i18n-noDataText="@@societiesNoData" noDataText="Noch keine Gesellschaften">
                <dxo-scrolling mode="standard"></dxo-scrolling>
                <dxo-header-filter [visible]="true"></dxo-header-filter>
                <dxo-paging [enabled]="false"></dxo-paging>

                <!-- Searched from the shared bar above; the grid's own search panel stays hidden. -->
                <dxo-search-panel [visible]="false" [text]="searchTerm"></dxo-search-panel>

                <dxi-column dataField="legalName" i18n-caption="@@societyLegalName" caption="Full legal name" sortOrder="asc"></dxi-column>
                <dxi-column dataField="legalForm" i18n-caption="@@societyLegalForm" caption="Legal form" [calculateCellValue]="legalFormText"></dxi-column>
                <dxi-column dataField="status" i18n-caption="@@societyStatus" caption="Company status" [calculateCellValue]="statusText"></dxi-column>
                <!-- Same project pills as the contract table: as many as fit, the rest as "+N". -->
                <dxi-column
                    name="projects"
                    i18n-caption="@@societyPvProjects"
                    caption="PV Projects"
                    [minWidth]="160"
                    [allowSorting]="false"
                    [calculateCellValue]="projectsCellValue"
                    [calculateFilterExpression]="projectsFilterExpression"
                    cellTemplate="projectsCellTemplate">
                    <dxo-header-filter [dataSource]="projectHeaderFilterOptions"></dxo-header-filter>
                    <div *dxTemplate="let item of 'projectsCellTemplate'">
                        <app-projects-cell [links]="item.data?.projects"></app-projects-cell>
                    </div>
                </dxi-column>
            </dx-data-grid>
        </div>
        }
    </div>
</div>
